import React, { FocusEventHandler } from 'react';
import EDMenuButton from '../../../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import { ElementType } from '../../../../../../BaseComponents/LocalMenu/EDLocalMenu';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import { SpacingProps } from '@mui/system';

export interface IMenuProps extends SpacingProps {
  id: string;
  collection?: IClientBusinessModel;
  className?: string;
  highEmphasis?: boolean;
  children?: ElementType;
  disabled?: boolean;
  innerRef?: React.MutableRefObject<any | null>;
  directEditMode?: boolean;
  hide?: boolean;
  /** Visa bara vid hover, kan användas för att minska upprepade funktionsmenyer i listor  */
  onlyOnHover?: boolean;
  buttonRef?: React.MutableRefObject<HTMLButtonElement | null>;
  disableTabbing?: boolean;
  onFocus?: FocusEventHandler<HTMLButtonElement>;
  testId?: string;
}

const FunctionMenu: React.FunctionComponent<
  React.PropsWithChildren<IMenuProps>
> = props => {
  const {
    id,
    collection,
    className,
    highEmphasis,
    children,
    disabled,
    innerRef,
    directEditMode,
    hide,
    onlyOnHover,
    buttonRef,
    ...spacingProps
  } = props;
  return (
    <EDMenuButton
      iconColor="inherit"
      tooltip="Funktioner"
      icon={
        <EDIcon
          color={props.disabled ? 'disabled' : 'inherit'}
          iconType="more_vert"
          size="medium"
        />
      }
      hide={hide}
      highEmphasis={highEmphasis}
      onlyOnHover={onlyOnHover}
      disabled={disabled}
      noClickPropagation
      // innerRef={props.innerRef}
      buttonRef={buttonRef}
      testId={props.testId ?? 'FunctionMenu'}
      onFocus={props.onFocus}
      {...spacingProps}
    >
      {children}
    </EDMenuButton>
  );
};

export default FunctionMenu;
